

(function ($) {
  ///////////////////////////////////////////////////////////////////////////
  //slick
  ///////////////////////////////////////////////////////////////////////////
  //
  //
  //  put on '.hero .zone .feature-wrap' or just copy and paste below to initiate slick
  /////////////////////////////////////////////////////////
  //                                                     //
  //  $('.hero .zone .feature-wrap').initiateSlick();    //
  //                                                     //
  /////////////////////////////////////////////////////////
  //
  //

  $.fn.initiateSlick = function (options, callback) {

    var settings = $.extend({
      slider_speed: 0,
      nextArrow: '',
      prevArrow: '',
      fade: true,
    }, options)

    var placeholder_speed = settings.slider_speed; //change this if you want to test different speeds
    var placeholder_initial_slide = 0; //change this if you want to test different starting slides
    var promo_speed = (typeof cfg_promo_speed == "undefined") ? placeholder_speed : cfg_promo_speed; //pull the global variable if it exists
    var initial_slide = (typeof cfg_promo_initial_slide == "undefined") ? placeholder_initial_slide : cfg_promo_initial_slide; //pull the global variable if it exists
    var autoplay = (promo_speed == 0) ? false : true;
    var slide_selector_class = $(this);

    // Slick SLide
    $(document).ready(function () {
      $(slide_selector_class).slick({
       
        autoplay: autoplay,
        autoplaySpeed: promo_speed,
        initialSlide: initial_slide,
        dots: true,
        infinite: true,
        slide: ".feature",
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 0,
        fade: settings.fade,
        pauseOnHover: true,
        cssEase: 'linear',
        // Custom arrows
        nextArrow: settings.nextArrow,
        prevArrow: settings.prevArrow,
        arrows: true
      });
    });
    // END Slick SLide


    if (typeof callback == 'function') { // make sure the callback is a function
      callback.call(this); // brings the scope to the callback
    }
  }


  ///////////////////////////////////////////////////////////////////////////
  //slick end
  ///////////////////////////////////////////////////////////////////////////





})(jQuery); // or even jQuery.noConflict()